export class HtmlTemplate {
  public constructor() {
    this.ID = 0;
    this.HTMLTemplateTypeID = 0;
    this.HTML = '';
    this.Title = '';
    this.Usernum = 0;
    this.TemplateType = '';
    this.UserName = '';
    this.Subject = '';
    this.FromEmail = '';
  }
  public ID: number;
  public HTMLTemplateTypeID: number;
  public HTML: string;
  public Title: string;
  public Usernum: number;
  public TemplateType: string;
  public UserName: string;
  public Subject: string;
  public FromEmail: string;
}
